import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import api from '../../api/client';
import OrgSettingsModal from '../OrgSettingsModal';

export default function Topbar({ title }) {
  const { user, logout, refreshUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sp, setSp] = useSearchParams();
  const dashboardScope = sp.get('scope') === 'org' ? 'org' : 'personal';
  const showDashboardToggle = location.pathname === '/' && user?.is_leader;
  const setScope = (s) => {
    const next = new URLSearchParams(sp);
    if (s === 'org') next.set('scope', 'org'); else next.delete('scope');
    setSp(next, { replace: true });
  };
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [profileForm, setProfileForm] = useState({});
  const [profileMsg, setProfileMsg] = useState('');
  const [profileLoading, setProfileLoading] = useState(false);
  const [showPdfName, setShowPdfName] = useState(false);
  const [pdfPattern, setPdfPattern] = useState('');
  const [pdfSaving, setPdfSaving] = useState(false);
  const [pdfMsg, setPdfMsg] = useState('');
  const [showOrgSettings, setShowOrgSettings] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  const openProfile = () => {
    setProfileForm({ name:user?.name||'', initials:user?.initials||'', position:user?.position||'', phone:user?.phone||'', current_password:'', new_password:'', confirm_password:'' });
    setProfileMsg(''); setShowProfile(true); setShowUserMenu(false);
  };

  const saveProfile = async () => {
    setProfileMsg(''); setProfileLoading(true);
    try {
      // 기본정보 수정
      await api.put('/auth/profile', { name:profileForm.name, initials:profileForm.initials, position:profileForm.position, phone:profileForm.phone });

      // 비밀번호 변경 (입력한 경우만)
      if (profileForm.new_password) {
        if (profileForm.new_password !== profileForm.confirm_password) { setProfileMsg('새 비밀번호가 일치하지 않습니다.'); setProfileLoading(false); return; }
        if (profileForm.new_password.length < 4) { setProfileMsg('비밀번호는 4자리 이상이어야 합니다.'); setProfileLoading(false); return; }
        await api.post('/auth/change-password', { current_password:profileForm.current_password, new_password:profileForm.new_password });
      }

      setProfileMsg('저장되었습니다.');
      setTimeout(()=>setShowProfile(false), 1000);
    } catch (e) { setProfileMsg(e.message); }
    finally { setProfileLoading(false); }
  };

  return (
    <>
      <div className="topbar">
        <div style={{display:'flex',alignItems:'center',gap:14}}>
          <div className="topbar-title">{title}</div>
          {showDashboardToggle && (
            <div style={{display:'flex',gap:6}}>
              <button className={`btn btn-sm ${dashboardScope==='personal' ? 'btn-primary' : 'btn-outline'}`}
                onClick={()=>setScope('personal')}>👤 본인</button>
              <button className={`btn btn-sm ${dashboardScope==='org' ? 'btn-primary' : 'btn-outline'}`}
                onClick={()=>setScope('org')}>👥 조직</button>
            </div>
          )}
        </div>
        <div className="topbar-right">
          <div style={{ position:'relative' }}>
            <div className="topbar-user" style={{ cursor:'pointer' }} onClick={() => setShowUserMenu(!showUserMenu)}>
              <div className="avatar">{user?.name?.[0]||'U'}</div>
              <div>
                <div style={{ fontWeight:600, fontSize:13 }}>{user?.name||'사용자'}</div>
                <div style={{ fontSize:11, color:'#94a3b8' }}>{user?.group_name||''}</div>
              </div>
              <span style={{ fontSize:10, color:'#94a3b8' }}>▼</span>
            </div>
            {showUserMenu && (
              <div style={{ position:'absolute', top:'100%', right:0, marginTop:8, background:'#fff', border:'1px solid #e2e8f0', borderRadius:10, boxShadow:'0 4px 16px rgba(0,0,0,0.1)', minWidth:180, zIndex:50, overflow:'hidden' }}>
                <div style={{ padding:'12px 16px', borderBottom:'1px solid #f1f5f9', fontSize:12, color:'#64748b' }}>
                  {user?.email}<br/><span style={{ fontSize:11 }}>{user?.org_name} · {user?.position}</span>
                </div>
                <div onClick={openProfile} style={{ padding:'10px 16px', fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', gap:8 }}
                  onMouseEnter={e=>e.currentTarget.style.background='#f8fafc'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  ⚙ 정보 변경
                </div>
                <div onClick={()=>{setPdfPattern(user?.preferences?.pdf_filename||'');setPdfMsg('');setShowPdfName(true);setShowUserMenu(false);}} style={{ padding:'10px 16px', fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', gap:8 }}
                  onMouseEnter={e=>e.currentTarget.style.background='#f8fafc'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  📄 PDF 파일명 설정
                </div>
                <div onClick={()=>{setShowOrgSettings(true);setShowUserMenu(false);}} style={{ padding:'10px 16px', fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', gap:8 }}
                  onMouseEnter={e=>e.currentTarget.style.background='#f8fafc'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  ⚙ 조직 설정
                </div>
                <div onClick={handleLogout} style={{ padding:'10px 16px', fontSize:13, cursor:'pointer', color:'#ef4444', display:'flex', alignItems:'center', gap:8 }}
                  onMouseEnter={e=>e.currentTarget.style.background='#fef2f2'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  🚪 로그아웃
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 정보 변경 모달 */}
      {showProfile && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ background:'#fff', borderRadius:14, padding:28, width:460, maxHeight:'85vh', overflowY:'auto' }}>
            <div style={{ fontSize:16, fontWeight:700, marginBottom:16, paddingBottom:10, borderBottom:'1px solid #e2e8f0', display:'flex', justifyContent:'space-between' }}>
              <span>정보 변경</span><span style={{ cursor:'pointer', color:'#94a3b8' }} onClick={()=>setShowProfile(false)}>✕</span>
            </div>
            {profileMsg && <div className={`alert ${profileMsg.includes('저장')? 'alert-info':'alert-danger'}`} style={{ marginBottom:12 }}>{profileMsg}</div>}
            <div className="form-row">
              <div className="form-group" style={{ flex:1 }}><label className="form-label">이름</label><input className="form-input" value={profileForm.name} onChange={e=>setProfileForm({...profileForm, name:e.target.value})} /></div>
              <div className="form-group" style={{ flex:1 }}><label className="form-label">고유 이니셜</label><input className="form-input" value={profileForm.initials} onChange={e=>setProfileForm({...profileForm, initials:e.target.value.toUpperCase()})} maxLength={5} /></div>
            </div>
            <div className="form-row">
              <div className="form-group" style={{ flex:1 }}><label className="form-label">직책</label><input className="form-input" value={profileForm.position} onChange={e=>setProfileForm({...profileForm, position:e.target.value})} /></div>
              <div className="form-group" style={{ flex:1 }}><label className="form-label">휴대전화번호</label><input className="form-input" value={profileForm.phone} onChange={e=>setProfileForm({...profileForm, phone:e.target.value})} placeholder="010-0000-0000" /></div>
            </div>
            <div style={{ borderTop:'1px solid #e2e8f0', marginTop:8, paddingTop:12 }}>
              <div style={{ fontSize:13, fontWeight:700, marginBottom:8 }}>비밀번호 변경 <span style={{ fontWeight:400, color:'#94a3b8', fontSize:11 }}>(변경하지 않으려면 비워두세요)</span></div>
              <div className="form-group"><label className="form-label">현재 비밀번호</label><input className="form-input" type="password" value={profileForm.current_password} onChange={e=>setProfileForm({...profileForm, current_password:e.target.value})} /></div>
              <div className="form-row">
                <div className="form-group" style={{ flex:1 }}><label className="form-label">새 비밀번호</label><input className="form-input" type="password" value={profileForm.new_password} onChange={e=>setProfileForm({...profileForm, new_password:e.target.value})} /></div>
                <div className="form-group" style={{ flex:1 }}><label className="form-label">새 비밀번호 확인</label><input className="form-input" type="password" value={profileForm.confirm_password} onChange={e=>setProfileForm({...profileForm, confirm_password:e.target.value})} /></div>
              </div>
            </div>
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:8 }}>
              <button className="btn btn-outline" onClick={()=>setShowProfile(false)}>취소</button>
              <button className="btn btn-primary" onClick={saveProfile} disabled={profileLoading}>{profileLoading?'저장 중...':'저장'}</button>
            </div>
          </div>
        </div>
      )}

      {/* PDF 파일명 설정 모달 */}
      {showPdfName && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ background:'#fff', borderRadius:14, padding:28, width:520 }}>
            <div style={{ fontSize:16, fontWeight:700, marginBottom:16, paddingBottom:10, borderBottom:'1px solid #e2e8f0', display:'flex', justifyContent:'space-between' }}>
              <span>PDF 파일명 설정</span><span style={{ cursor:'pointer', color:'#94a3b8' }} onClick={()=>setShowPdfName(false)}>✕</span>
            </div>
            {pdfMsg && <div className={`alert ${pdfMsg.includes('저장')? 'alert-info':'alert-danger'}`} style={{ marginBottom:12 }}>{pdfMsg}</div>}

            <div className="form-group">
              <label className="form-label">파일명 규칙</label>
              <input className="form-input" value={pdfPattern} onChange={e=>setPdfPattern(e.target.value)} placeholder="{견적번호}_{고객사명}" id="pdfPatternInput" />
            </div>

            <div style={{ background:'#f8fafc', borderRadius:8, padding:'10px 14px', marginBottom:14, fontSize:12 }}>
              <span style={{ color:'#64748b' }}>미리보기: </span>
              <strong>{(pdfPattern||'{견적번호}_{고객사명}')
                .replace('{견적번호}','INT-260516-KCS-0001').replace('{견적일자}','260516')
                .replace('{고객사명}','ABC Trading').replace('{수신자}','홍길동')
                .replace('{사업명}','OO기관 네트워크 구축').replace('{최종사용자}','한국통신')
                .replace('{작성자}',user?.name||'김철수').replace('{이니셜}',user?.initials||'KCS')
                .replace('{버전}','1').replace('{오늘날짜}',(() => { const n=new Date(); return String(n.getFullYear()).slice(2)+String(n.getMonth()+1).padStart(2,'0')+String(n.getDate()).padStart(2,'0'); })())
              }.pdf</strong>
            </div>

            <div style={{ marginBottom:14 }}>
              <div style={{ fontSize:11, fontWeight:600, color:'#64748b', marginBottom:6 }}>사용 가능 변수 (클릭하여 삽입)</div>
              <div style={{ display:'flex', flexWrap:'wrap', gap:5 }}>
                {['{견적번호}','{견적일자}','{고객사명}','{수신자}','{사업명}','{최종사용자}','{작성자}','{이니셜}','{버전}','{오늘날짜}'].map(v=>(
                  <span key={v} onClick={()=>{
                    const el=document.getElementById('pdfPatternInput');
                    if(el){const s=el.selectionStart,e=el.selectionEnd;const nv=pdfPattern.slice(0,s)+v+pdfPattern.slice(e);setPdfPattern(nv);setTimeout(()=>{el.focus();el.setSelectionRange(s+v.length,s+v.length);},0);}
                    else setPdfPattern(pdfPattern+v);
                  }}
                    style={{ padding:'3px 8px', background:'#eff6ff', color:'#2563eb', borderRadius:4, fontSize:11, cursor:'pointer', fontWeight:600, border:'1px solid #bfdbfe' }}>{v}</span>
                ))}
              </div>
            </div>

            <div style={{ background:'#fffbeb', border:'1px solid #fde68a', borderRadius:8, padding:'10px 14px', fontSize:11, color:'#92400e', lineHeight:1.7, marginBottom:16 }}>
              ℹ 변수와 구분자를 조합하여 원하는 파일명을 만드세요.<br/>
              특수문자(/ \ : * ? " &lt; &gt; |)는 자동으로 제거됩니다.<br/>
              비워두면 기본값 <strong>{'{견적번호}_{고객사명}'}</strong>이 적용됩니다.
            </div>

            <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
              <button className="btn btn-outline" onClick={()=>setShowPdfName(false)}>취소</button>
              <button className="btn btn-primary" disabled={pdfSaving} onClick={async()=>{
                setPdfSaving(true); setPdfMsg('');
                try { await api.put('/auth/preferences',{pdf_filename:pdfPattern||null}); await refreshUser(); setPdfMsg('저장되었습니다.'); setTimeout(()=>setShowPdfName(false),800); }
                catch(e) { setPdfMsg(e.message); } finally { setPdfSaving(false); }
              }}>{pdfSaving?'저장 중...':'저장'}</button>
            </div>
          </div>
        </div>
      )}

      <OrgSettingsModal open={showOrgSettings} onClose={()=>setShowOrgSettings(false)} />
    </>
  );
}
